import { useDragLayer } from 'react-dnd';
import { cn } from '@design-system';

import { COLUMN_DND_TYPE, type ColumnDragItem } from '@/features/policies-comparison';

export function ColumnDragLayer() {
  const { itemType, isDragging, item, currentOffset } = useDragLayer(monitor => ({
    itemType: monitor.getItemType(),
    isDragging: monitor.isDragging(),
    item: monitor.getItem() as ColumnDragItem | null,
    currentOffset: monitor.getClientOffset(),
  }));

  if (!isDragging || itemType !== COLUMN_DND_TYPE || !item || !currentOffset) {
    return null;
  }

  return (
    <div className="z-9999 pointer-events-none fixed inset-0">
      <div
        style={{
          transform: `translate(${currentOffset.x - 128}px, ${currentOffset.y - 140}px) rotate(3deg)`,
        }}
        className="w-64 md:w-72"
      >
        <div className="bg-background border-primary/15 rounded-xl border shadow-2xl shadow-black/20">
          <div className="flex h-24 flex-col md:h-28">
            <div className="bg-primary/10 text-primary-dark rounded-t-xl py-1 text-center text-xs font-medium md:py-2">
              {item.title}
            </div>
            <div className="grid flex-1 place-items-center px-3 py-3 md:px-16 md:py-4">
              {item.img ? (
                <img
                  src={item.img}
                  alt={item.title}
                  className={cn('mx-auto h-auto w-28 md:w-32', item.imgClassName)}
                />
              ) : (
                <div className="text-primary-dark text-balance py-1.5 text-lg font-semibold md:text-xl">
                  {item.title}
                </div>
              )}
            </div>
          </div>
          <div className="border-primary/15 space-y-3 border-t px-4 py-3 opacity-60">
            <div className="bg-muted h-3 w-3/4 rounded" />
            <div className="bg-muted h-3 w-1/2 rounded" />
            <div className="bg-muted h-3 w-2/3 rounded" />
          </div>
        </div>
      </div>
    </div>
  );
}
